import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=f303a5d4&scoped=true&"
import script from "./NavBar.vue?vue&type=script&lang=js&"
export * from "./NavBar.vue?vue&type=script&lang=js&"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=f303a5d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f303a5d4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Container: require('/vercel/path0/components/ui/Container.vue').default})
